import { render } from "./ImportModal.vue?vue&type=template&id=7aa27378"
import script from "./ImportModal.vue?vue&type=script&lang=js"
export * from "./ImportModal.vue?vue&type=script&lang=js"
script.render = render

export default script